import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

class Announcements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      isCloseHovered: false
    };
  }

  // Inline styles to ensure they work in production
  styles = {
    banner: {
      background: 'linear-gradient(135deg, #FF6307 0%, #e55a00 100%)',
      position: 'relative',
      boxShadow: '0 4px 20px rgba(255, 99, 7, 0.3)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      paddingTop: '40px'
    },
    contentWrapper: {
      position: 'relative',
      padding: '1rem 0',
      color: '#fff'
    },
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '16px',
      marginBottom: '8px'
    },
    titleSection: {
      flex: 1
    },
    title: {
      fontWeight: 700,
      margin: '0 0 8px 0',
      color: '#fff',
      lineHeight: 1.2
    },
    body: {
      marginLeft: '2rem'
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: '7px'
    },
    item: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px'
    },
    bullet: {
      width: '8px',
      height: '8px',
      background: '#fff',
      borderRadius: '50%',
      marginTop: '8px',
      flexShrink: 0,
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
    },
    text: {
      lineHeight: 1.6,
      color: 'rgba(255, 255, 255, 0.95)'
    },
    closeBtn: {
      position: 'absolute',
      top: '20px',
      right: 0,
      background: 'rgba(255, 255, 255, 0.1)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '8px',
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      backdropFilter: 'blur(10px)'
    }
  };

  handleClose = () => {
    this.setState({ isVisible: false });
  };

  handleCloseHover = (isHovered) => {
    this.setState({ isCloseHovered: isHovered });
  };

  render() {
    if (!this.state.isVisible) {
      return <div style={{ paddingTop: '20px' }}><br/></div>;
    }

    return (
        <>
        
      <div style={this.styles.banner}>
        {/* <br /> */}
        <div className="container">
          <div style={this.styles.contentWrapper}>
            {/* Icon and Header */}
            <div style={this.styles.header}>
              {/* <div className="announcements-icon">
                <FontAwesomeIcon icon={faBell} />
              </div> */}
              <div style={this.styles.titleSection}>
                <h4 style={this.styles.title}>Action Required</h4>
                
                  {/* <FontAwesomeIcon icon={faExclamationTriangle} /> */}
                  <h4>Starting Oct 15, 2025</h4>
                
              </div>
            </div>

            {/* Content */}
            <div style={this.styles.body}>
              <div style={this.styles.list}>
                <div style={this.styles.item}>
                  <div style={this.styles.bullet}></div>
                  <h4 style={{...this.styles.text, lineHeight: "1.5", marginBottom: "0px" }}>
                  New users signing up will be required to verify their customer status by providing a valid <a 
                   target="_blank"
                   rel="noreferrer"
                   style={{borderBottom: '1px solid #fff', color: '#fff', textDecoration: 'underline'}}
                  href="/locating-controllerid-customerid">Controller ID or Customer ID</a> during Signup.
                  </h4>
                </div>
                <div style={this.styles.item}>
                  <div style={this.styles.bullet}></div>
                  <h4 style={{...this.styles.text, lineHeight: "1.5", marginBottom: "0px" }}>
                  Existing users who are already registered will be prompted once to complete this same authorization during their first login on/after above date. After successful validation, you will be redirected to the usual Zendesk Login screen. Future logins will not require reauthorization.
                  </h4>
                </div>
              </div>
            </div>

            {/* Close Button */}
            <button
              type="button"
              style={{
                ...this.styles.closeBtn,
                background: this.state.isCloseHovered ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)',
                transform: this.state.isCloseHovered ? 'scale(1.05)' : 'scale(1)',
                boxShadow: this.state.isCloseHovered ? '0 4px 12px rgba(0, 0, 0, 0.2)' : 'none'
              }}
              // className='announcements-close-btn'
              onClick={this.handleClose}
              onMouseEnter={() => this.handleCloseHover(true)}
              onMouseLeave={() => this.handleCloseHover(false)}
              aria-label="Close announcements"
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: '16px', color: '#fff' }} />
            </button>
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default Announcements;
